import { AdminAuditLog } from '@hakimo-ui/hakimo/types';
import { DiffBody } from './DiffBody';
import { PriorState } from './PriorState';

/** What a config change made outside the application actually was. */
export function ConfigChangeDetails({ entry }: { entry: AdminAuditLog }) {
  const { configDiff, configBefore } = entry;

  return (
    <details className="mt-1">
      <summary className="text-primary-600 dark:text-primary-400 cursor-pointer text-xs">
        Show what changed
      </summary>
      <div className="mt-2 rounded-lg bg-gray-50 p-3 dark:bg-gray-900">
        {configDiff && <DiffBody diff={configDiff} />}
        {configBefore && <PriorState config={configBefore} />}
      </div>
    </details>
  );
}

export default ConfigChangeDetails;
